import { Autocomplete, DatePicker, Input } from '@fullscreendigital/carrefour-dex-fe'
import { DownloadIcon } from 'icons'
import { getCurrentDate } from 'utils/helpers'

export const toolbarActions = ({
                                 totalCount,
                                 exportFileCSV,
                                 isCSVExportLoading
                               }) => {
  let actions = []

  if (totalCount>0 && totalCount<=5000) {
    actions = [
      ...actions,
      {
        label: isCSVExportLoading ? 'Export in curs...' : 'Export CSV',
        icon: <DownloadIcon />,
        onClick: isCSVExportLoading ? () => {} : exportFileCSV
      }
    ]
  }

  return actions
}

export const getColumns = downloadImage => [
  {
    title: 'Depozit',
    field: 'depositName',
    align: 'left',
    type: 'string',
    sticky: true,
    width: '100px'
  },
  {
    title: 'Magazin',
    field: 'shopName',
    align: 'left',
    type: 'string',
    sticky: true,
    width: '100px'
  },
  {
    title: 'HUB',
    field: 'receptionHubName',
    align: 'left',
    type: 'string',
    sticky: true,
    width: '100px'
  },
  {
    title: 'Societate',
    field: 'parentSociety',
    align: 'left',
    type: 'string',
    sticky: true,
    width: '100px'
  },
  {
    title: 'Tip suport asteptat',
    field: 'supportTypeExpected',
    align: 'left',
    type: 'string',
    width: '100px'
  },
  {
    title: 'Tip suport confirmat',
    field: 'supportTypeConfirmed',
    align: 'left',
    type: 'string',
    width: '100px'
  },
  {
    title: 'Locatie camion',
    field: 'type',
    align: 'left',
    type: 'string',
    width: '100px'
  },
  {
    title: 'Numar inmatriculare',
    field: 'truckNumber',
    align: 'left',
    type: 'string',
    width: '100px'
  },
  {
    title: 'Cod suport',
    field: 'supportCode',
    align: 'left',
    type: 'string',
    width: '100px'
  },
  {
    title: 'Bon livrare',
    field: 'deliveryTicketExternalId',
    align: 'left',
    type: 'string',
    width: '100px'
  },
  {
    title: 'Numar aviz',
    field: 'noticeNumber',
    align: 'left',
    type: 'string',
    width: '100px'
  },
  {
    title: 'Intrare',
    field: 'intactNumber',
    align: 'left',
    type: 'string',
    width: '100px'
  },
  {
    title: 'Iesire',
    field: 'brokenNumber',
    align: 'left',
    type: 'string',
    width: '100px'
  },
  {
    title: 'Stoc final dupa inventar',
    field: 'difference',
    align: 'left',
    type: 'string',
    disableSorting: true,
    width: '100px'
  },
  {
    title: 'Data',
    field: 'created',
    align: 'left',
    type: 'string',
    width: '100px'
  },
  {
    title: 'Descarca imagini',
    field: 'pictureId',
    align: 'left',
    type: 'string',
    width: '100px',
    disableSorting: true,
    render: row =>
      row.pictureId ? (
        <div onClick={() => downloadImage(row.pictureId)}>
          <DownloadIcon />
        </div>
      ) : (
        <div />
      )
  }
]

const currentDate = getCurrentDate()

export const getFilters = ({
  shopOptions,
  depositOptions,
  hubOptions,
  supportTypeFlowOptions,
  supportTypeOptions,
  parentSocietyOptions,
  nonCompliantReasonOptions
}) => [
  {
    name: 'shopCode',
    value: undefined,
    filter: (
      <Autocomplete
        variant="outlined"
        label="Selecteaza magazin"
        options={shopOptions || []}
        multiple
      />
    ),
    type: 'autocomplete',
    label: 'Magazin'
  },
  {
    name: 'hubId',
    value: undefined,
    filter: (
      <Autocomplete variant="outlined" label="Selecteaza Hub" options={hubOptions || []} multiple />
    ),
    type: 'autocomplete',
    label: 'Hub'
  },
  {
    name: 'depositId',
    value: undefined,
    filter: (
      <Autocomplete
        variant="outlined"
        label="Selecteaza Depozit"
        options={depositOptions || []}
        multiple
      />
    ),
    type: 'autocomplete',
    label: 'Depozit'
  },
  {
    name: 'type',
    value: undefined,
    filter: (
      <Autocomplete
        variant="outlined"
        label="Selecteaza Tip"
        options={supportTypeFlowOptions || []}
        multiple
      />
    ),
    type: 'autocomplete',
    label: 'Tip'
  },
  {
    name: 'supportTypeId',
    value: undefined,
    filter: (
      <Autocomplete
        variant="outlined"
        label="Selecteaza Tip Suport"
        options={supportTypeOptions || []}
        multiple
      />
    ),
    type: 'autocomplete',
    label: 'Tip Suport'
  },
  {
    name: 'parentSociety',
    value: undefined,
    filter: (
      <Autocomplete
        variant="outlined"
        label="Selecteaza Societate"
        options={parentSocietyOptions || []}
        multiple
      />
    ),
    type: 'autocomplete',
    label: 'Societate'
  },
  {
    name: 'supportCode',
    label: 'Cod suport',
    type: 'text',
    filter: <Input type="text" name="supportCode" label="Cod suport" variant="outlined" />
  },
  {
    name: 'ticketNumber',
    label: 'Bon livrare',
    type: 'text',
    filter: <Input type="text" name="ticketNumber" label="Bon livrare" variant="outlined" />
  },
  {
    name: 'noticeNumber',
    label: 'Numar aviz',
    type: 'text',
    filter: <Input type="text" name="noticeNumber" label="Numar aviz" variant="outlined" />
  },
  {
    name: 'nonCompliantReason',
    value: undefined,
    filter: (
      <Autocomplete
        variant="outlined"
        label="Selecteaza conformitate suport"
        options={nonCompliantReasonOptions || []}
      />
    ),
    type: 'autocomplete',
    label: 'Conformitate suport'
  },
  {
    name: 'createdDate',
    value: currentDate,
    filter: (
      <DatePicker
        label="Selecteaza data de la "
        variant="outlined"
        value={currentDate}
        onChange={() => {}}
        required
        adapterLocale="ro"
        modalLabel="Selecteaza data"
        closeButtonLabel="Anuleaza"
        confirmButtonLabel="Confirma"
      />
    ),
    type: 'date',
    label: 'Data de la'
  },
  {
    name: 'endedDate',
    value: currentDate,
    filter: (
      <DatePicker
        label="Selecteaza data pana la "
        variant="outlined"
        value={currentDate}
        onChange={() => {}}
        required
        adapterLocale="ro"
        modalLabel="Selecteaza data"
        closeButtonLabel="Anuleaza"
        confirmButtonLabel="Confirma"
      />
    ),
    type: 'date',
    label: 'Data pana la'
  }
]
